import "./index.scss";
import { activateEnquiry } from "./enquiry";

document.addEventListener("DOMContentLoaded", () => {
  activateEnquiry("SNAM Group Website");
});
